import React from 'react'
import DetailHeader from '../../../shared/DetailHeader'
import { personSubTitle } from '../../../../common';

const PersonDetailStickyHeader = (props) => {
    const person = props.person;
    const detailHeaderProps = {
        imageUrl: person.PerThumbnail,
        title: person.PerNameTxt,
        txt: personSubTitle(person),
    };

    return (
        <DetailHeader relay={props.relay} detail={ detailHeaderProps } />
    );
};

export default PersonDetailStickyHeader;


// WEBPACK FOOTER //
// ./app/components/Person/Detail/StickyHeader/StickyHeader.jsx